<template>
  <div id="app">
    <transition name="fade">
      <router-view/>
    </transition>
  </div>
</template>

<script>
  import { getToken } from '@/utils/auth'
  import {title} from "@/common/const";

  //a
  export default {
    name: 'App',
    data(){
        return{
          getToken:getToken(),
          flag:true,
          audioSrc:require('@/assets/baojing.mp3'),
          staffCode:"",
          path: this.$websocketUrl,
          socket:"",
          audio:"",
          setTimeoutPaused:'',
          lockReconnect: false,//是否真正建立连接
          timeout: 30*1000,//30秒一次心跳
          timeoutObj: null,//心跳心跳倒计时
          serverTimeoutObj: null,//心跳倒计时
          timeoutnum: null,//断开 重连倒计时


          title:title,

        }
    },
    created(){

      document.title = this.title;

    },
  }
</script>

<style>
  html,body{padding: 0px;margin: 0px;height: 100%;}
  #app{height: 100%;}
</style>
